import styled from 'styled-components';

export const ReportsNestedTableBodyCont = styled.div`
  position: relative;
  min-height: 90px;
`;

export const NestedTableSpinnerCont = styled.div`
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
